import { render, staticRenderFns } from "./IngredientItemDetail.vue?vue&type=template&id=967114a8&"
import script from "./IngredientItemDetail.vue?vue&type=script&lang=js&"
export * from "./IngredientItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports